import { Children, cloneElement } from "react";

import { AccordionItem } from "./AccordionItem";

import "./Accordion.css";

export interface AccordionProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  variant?: "plus-minus" | "chevron";
}

export function Accordion({
  children,
  style,
  variant = "plus-minus",
}: AccordionProps) {
  return (
    <div className="Accordion" style={style}>
      {Children.map(children, (child) =>
        cloneElement(child as React.ReactElement, { variant }),
      )}
    </div>
  );
}

Accordion.Item = AccordionItem;
